<template v-if="!loading">
    <transition :name="$route.meta.transition || 'fade'">
        <div>
            <TickerTape :options="tickerTapeOptions" />
            <div class="container mx-auto py-4">
                <div id="content" class="flex flex-col lg:flex-row lg:divide-x divide-gray-300">
                    <div class="lg:w-3/4 lg:pr-8">
                        <div id="highlights" class="relative">
                            <div class="flex flex-row justify-between mb-3">
                                <div class="mb-4 block">
                                    <h1 class="xl3_bold">{{ response_data.data.meta.snippet.title }}</h1>
                                </div>
                                <div class="flex flex-row gap-4 items-center"></div>
                            </div>

                            <Loading :loading="loading">
                                <div class="transition-all ease-in-out duration-500 items-center">
                                    <YoutubePlayer :source="response_data.data.meta.snippet.resourceId.videoId" />
                                </div>
                            </Loading>

                            <h2 class="xl_bold py-4">{{ description }}</h2>
                            {{ $moment(this.response_data.data.published_at).format('DD.MM.YYYY') }}

                            <div class="mt-10 block">
                                <a href="/videos">
                                    <div class="flex flex-row gap-2 group-hover:gap-3 transition-all ease-in-out duration-500 items-center mt-2">
                                        {{ $t('news_all_videos') }}
                                        <Icon type="ArrowRight" viewBox="0 0 29 21" width="18" height="10" class="fill-none stroke-current" />
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="lg:w-1/4 lg:pl-8">
                        <SidebarListWithoutVideo />
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <component is="script" type="application/ld+json">
        { "@context": "http://schema.org", "@type": "VideoObject", "name": "{{ response_data.data.meta.snippet.title }}", "description": "{{ description }}", "thumbnailUrl": "{{
            response_data.data.meta.snippet.thumbnails.high.url
        }}", "uploadDate": "{{ $moment(response_data.data.published_at).format('YYYY-MM-DD') }}", "duration": "", "contentUrl": "{{ current_url }}", "embedUrl":
        "https://www.youtube.com/watch?v={{ response_data.data.meta.snippet.resourceId.videoId }}", "publisher": { "@type": "Organization", "name": "Hopf-Klinkmüller Capital
        Management GmbH & Co. KG", "logo": { "@type": "ImageObject", "url":
        "https://d178cgmue8nngv.cloudfront.net/191c401f-6590-4a75-9141-00db5731f946/hkcm/images/logo-on-light-background.svg" } } }
    </component>
</template>

<script>
import { TickerTape } from 'vue-tradingview-widgets';
import api from '../api';

export default {
    components: {
        TickerTape
    },

    async created() {
        this.loading = true;

        this.video_slug = this.$route.params.id;

        try {
            const socialMediaResponse = await api.get(`/api/v1/slugs/${this.video_slug}`);
            this.response_data1 = socialMediaResponse.data;
        } catch (error) {
            try {
                const socialMediaResponse = await api.get(`/api/v1/social-medias/${this.video_slug}`);
                this.response_data2 = socialMediaResponse.data;
            } catch (error) {
                console.error('Error fetching data', error);
            }
        }

        if (this.response_data1) {
            this.response_data = this.response_data1;
        } else {
            this.response_data = this.response_data2;
        }

        this.loading = false;

        this.title = this.response_data.data.meta.snippet.title + ' | HKCM';
        this.thumbnail_url = this.response_data.data.meta.snippet.thumbnails.high.url;
        this.video_id = this.response_data.data.meta.snippet.resourceId.videoId;
        this.published_at = this.response_data.data.published_at;

        // Just first part of description bis "Unsere". Rest is not needed, because it is only footer for youtube channel
        this.description = this.response_data.data.meta.snippet.description;
        const regex_pattern = /Unsere/i;
        const match = this.description.match(regex_pattern);
        if (match) {
            const textBeforeUnsere = this.description.slice(0, match.index);
            this.description = textBeforeUnsere;
        } else {
            this.description = null;
        }

        document.title = this.title;
        document.querySelector('meta[itemprop="name"]').setAttribute('content', this.title);
        document.querySelector('meta[itemprop="description"]').setAttribute('content', this.description);
        document.querySelector('meta[name="twitter:title"]').setAttribute('content', this.title);
        document.querySelector('meta[name="twitter:description"]').setAttribute('content', this.description);
        document.querySelector('meta[name="og:title"]').setAttribute('content', this.title);
        document.querySelector('meta[name="og:description"]').setAttribute('content', this.description);
    },

    data() {
        return {
            response_data: null,
            title: null,
            description: null,
            thumbnail_url: null,
            video_id: null,
            published_at: null,
            current_url: window.location.href,
            loading: false
        };
    }
};
</script>
